import axios from 'axios';
import store from '../store'
import { NULL } from 'sass';

const PREFIJO = "/api/PrsNtrsPv/";

export default {
    registroFormualrio(formulario, tipo) {
        let selectServicios = store.getters.getMantenimientosCotizar;
        const dto = {
            dt1: formulario.nombreUno,//si
            dt4: formulario.nombreDos,
            dt3: formulario.apellidoUno,//si
            dt5: formulario.numeroTelefono,//si
            dt6: formulario.email,//si
            dt8: store.getters.getHome.placa,
            dt10: formulario.ci,//si
            dt12: process.env.VUE_APP_FUENTE, 
            dt13: process.env.VUE_APP_API_KEY,
            dt14: process.env.VUE_APP_LINEA_NEGOCIO,
            dt15: formulario.tipoDocumento.dt1,//si
            dt16: process.env.VUE_APP_PAIS_NAME,
            dt17: formulario.tipoPersona.dt1,
            dt18: process.env.VUE_APP_MARCA, 
            dt21: formulario.numeroTelefono, //si
            dt24: store.getters.getVehiculo.dt3 === null ? "" : store.getters.getVehiculo.dt3,
            dt27: store.getters.getVehiculo.dt6 === null  ? process.env.VUE_APP_MARCA : store.getters.getVehiculo.dt6,
            dt28: store.getters.getVehiculo.dt7 === null ? "" : store.getters.getVehiculo.dt7,
            dt35: formulario.razonSocial,
            dt39: tipo,
            dt40: formulario.tipoTelefono.dt1, //si
            dt41: formulario.apellidoDos,
            ndt3: store.getters.getVehiculo.ndt3,
            ndt6: store.getters.getHome.agencia.id,//si
            ndt22: formulario.tipoDocumento.id,//si
            ndt23: formulario.tipoTelefono.id,//si
            bdt1: true, ////si
            elements:selectServicios,
            //idTrack: store.getters.getAplicacion.id
            
        }
        return axios.post(`${PREFIJO}VmCrPrsNtrs`, dto)
    },
}
